import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`現任 樂屋國際資訊 (股) 產品處 副總經理，以及 DDD Taiwan Community Organizer。
長期身處矩陣式組織，擔當多重角色，推動全組織敏捷與數位轉型。
組織管理營運上，擔任 People Manager 與 Technical Leader。產品設計開發上，作為 Agile Coach、Product Coach 與 Data Science Architect。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      